/**
* directives.macros Module
*
* Description
*/
var app = angular.module('directives.macros', []);

	require('./macros.directive.js');

module.exports = app;


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/macros/index.js
 ** module id = 174
 ** module chunks = 1
 **/